import { frontendURL } from '../../../helper/URLHelper';
import { FEATURE_FLAGS } from '../../../featureFlags';

const SalesFunnelIndex = () => import('./SalesFunnelIndex.vue');
const SalesFunnelReports = () => import('./SalesFunnelReports.vue');
const SalesFunnelSettings = () => import('./SalesFunnelSettings.vue');
const SalesFunnelTasks = () => import('./SalesFunnelTasks.vue');
const SalesFunnelActivityLog = () => import('./SalesFunnelActivityLog.vue');

export const routes = [
  {
    path: frontendURL('accounts/:accountId/sales-funnel'),
    name: 'sales_funnel',
    meta: {
      permissions: ['administrator', 'sales_funnel_view', 'sales_funnel_use'],
      featureFlag: FEATURE_FLAGS.SALES_FUNNEL,
    },
    component: SalesFunnelIndex,
  },
  {
    path: frontendURL('accounts/:accountId/sales-funnel/tasks'),
    name: 'sales_funnel_tasks',
    meta: {
      permissions: ['administrator', 'sales_funnel_view', 'sales_funnel_use'],
      featureFlag: FEATURE_FLAGS.SALES_FUNNEL,
    },
    component: SalesFunnelTasks,
  },
  {
    path: frontendURL('accounts/:accountId/sales-funnel/activity-log'),
    name: 'sales_funnel_activity_log',
    meta: {
      permissions: ['administrator', 'sales_funnel_activity_log'],
      featureFlag: FEATURE_FLAGS.SALES_FUNNEL,
    },
    component: SalesFunnelActivityLog,
  },
  {
    path: frontendURL('accounts/:accountId/sales-funnel/reports'),
    name: 'sales_funnel_reports',
    meta: {
      permissions: ['administrator', 'sales_funnel_reports'],
      featureFlag: FEATURE_FLAGS.SALES_FUNNEL,
    },
    component: SalesFunnelReports,
  },
  {
    path: frontendURL('accounts/:accountId/settings/sales-funnel-stages'),
    name: 'sales_funnel_settings',
    meta: {
      permissions: [
        'administrator',
        'sales_funnel_manage_stages',
        'sales_funnel_manage_products',
        'sales_funnel_manage_lost_reasons',
        'sales_funnel_manage_labels',
      ],
      featureFlag: FEATURE_FLAGS.SALES_FUNNEL,
    },
    component: SalesFunnelSettings,
  },
];
